'use client';

import {
  ComponentTypeEnum,
  sendProductAnalytics,
  UserActionEnum,
} from '@hyphengroup/cms-components/utils/analytics';
import { usePathname } from 'next/navigation';
import { ComponentFlexibleHeroBlock } from '$/(cms)/_modules/cmsService/types';
import { pushDataLayer } from '$/components/cms/pushDataLayer';
import { sessionAttributionTracker } from '$/modules/sessionAttributionTracking/sessionAttributionTracker';

/**
 * Click handler of a hero's Apply CTA: records the apply attribution and
 * fires the Product Hero Apply Now conversion. The event fires only when a
 * product is present; a Provider CTA records the attribution alone. Uses the
 * shared sendProductAnalytics helper so the payload (item_id, reward campaign,
 * product_context_parameter) matches the other apply events.
 */
export const useFlexibleHeroBlockApplyClick = (
  product: ComponentFlexibleHeroBlock['product'],
) => {
  const pathname = usePathname();

  return () => {
    sessionAttributionTracker.recordApplyClick();

    if (!product) {
      return;
    }

    sendProductAnalytics({
      event: 'product_click_apply',
      action: UserActionEnum.CLICK,
      componentType: ComponentTypeEnum.PRODUCT_CARD,
      componentTitle: 'Product Hero/CTA_Apply Now',
      itemListName: pathname ?? undefined,
      product,
      index: '0',
      pushDataLayer,
    });
  };
};
